export default __webpack_public_path__ + "static/media/visible-off.ac24f521.svg";